import { Typography } from '@material-ui/core'
import { Component } from 'react'

class ScheduleCalendarWarning extends Component {
  props: any
  render() {
    let events = this.props.record.events
    if (events.length && events[0].hos_clocks.length) {
      return <div></div>
    } else {
      return (
        <Typography variant="caption">
          This schedule was generated with HOSV1, so the HOS log summary column may not match the schedule
          built for this driver.
        </Typography>
      )
    }
  }
}

export default ScheduleCalendarWarning
